module.exports = __webpack_public_path__ + "static/media/menu-white-24dp.bb5c8bd7.svg";